var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("Question", {
    attrs: {
      title: _vm.isVGCable
        ? _vm.webstoreContent.vehicleCableQuestion.vg.title
        : _vm.webstoreContent.vehicleCableQuestion.ag.title,
      options: Object.values(
        _vm.isVGCable
          ? _vm.webstoreContent.vehicleCableQuestion.vg.options
          : _vm.webstoreContent.vehicleCableQuestion.ag.options
      ),
      selectedOption: _vm.selectedTypeOfReplacementCable,
      cableSelection: true,
    },
    on: { onOptionClick: _vm.setTypeOfReplacementCable },
    scopedSlots: _vm._u([
      {
        key: "subtitle",
        fn: function () {
          return [
            _c("p", [
              _c(
                "a",
                {
                  attrs: {
                    id: "cable-guide",
                    href: _vm.isVGCable
                      ? _vm.webstoreContent.vehicleCableGuide.fields.file.url
                      : _vm.webstoreContent.assetCableGuide.fields.file.url,
                    target: "_blank",
                  },
                },
                [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        _vm.isVGCable
                          ? _vm.webstoreContent.vehicleCableQuestion.vg.subtitle
                          : _vm.webstoreContent.vehicleCableQuestion.ag.subtitle
                      ) +
                      "\n        "
                  ),
                ]
              ),
            ]),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }